import { TodayAllocationPresentation } from '../models/today-allocation';

export const mockAllocations: TodayAllocationPresentation[] = [
  {
    allocationId: "00112214-ALLC-0001",
    symbol: "CHWY",
    side: "S",
    avgPrice: 16.47,
    totalQuantity: 10,
    totalValue: 164.7,
    orderDetail: [
      {
        allocationId: "00112214-ALLC-0001",
        orderId: 884191954,
        symbol: "CHWY",
        side: "S",
        execQuantity: 100,
        execPrice: 16.47,
        allcQuantity: 10,
        bowiBrokerId: -1
      }
    ],
    allocationDetails: [
      {
        allocationId: "00112214-ALLC-0001",
        accountId: "17250001",
        symbol: "CHWY",
        side: "S",
        price: 16.47,
        quantity: 10,
        ecnOrderId: "00112214-ALLC-0001-O0000-B0000",
        ecnExecId: "00112214-ALLC-0001-E0000-B0000",
        timestamp: "2024-05-21T13:33:55.983"
      }
    ],
    bowiBrokerId: -1,
    user: "",
    expanded: false
  },
  {
    allocationId: "00100644-ALLC-0002",
    symbol: "AAPL",
    side: "B",
    avgPrice: 192.31,
    totalQuantity: 5,
    totalValue: 961.55,
    orderDetail: [
      {
        allocationId: "00100644-ALLC-0002",
        orderId: 884191949,
        symbol: "AAPL",
        side: "B",
        execQuantity: 200,
        execPrice: 192.31,
        allcQuantity: 5,
        bowiBrokerId: -1
      }
    ],
    allocationDetails: [
      {
        allocationId: "00100644-ALLC-0002",
        accountId: "77773370",
        symbol: "AAPL",
        side: "B",
        price: 192.31,
        quantity: 5,
        ecnOrderId: "00100644-ALLC-0002-O0000-B0000",
        ecnExecId: "00100644-ALLC-0002-E0000-B0000",
        timestamp: "2024-05-21T13:58:49.07"
      }
    ],
    bowiBrokerId: -1,
    user: "",
    expanded: false
  },
  {
    allocationId: "00112214-ALLC-0002",
    symbol: "NFLX",
    side: "S",
    avgPrice: 645.36,
    totalQuantity: 10,
    totalValue: 6453.6,
    orderDetail: [
      {
        allocationId: "00112214-ALLC-0002",
        orderId: 884191955,
        symbol: "NFLX",
        side: "S",
        execQuantity: 200,
        execPrice: 645.36,
        allcQuantity: 10,
        bowiBrokerId: -1
      }
    ],
    allocationDetails: [
      {
        allocationId: "00112214-ALLC-0002",
        accountId: "17281593",
        symbol: "NFLX",
        side: "S",
        price: 645.36,
        quantity: 10,
        ecnOrderId: "00112214-ALLC-0002-O0000-B0000",
        ecnExecId: "00112214-ALLC-0002-E0000-B0000",
        timestamp: "2024-05-21T13:58:49.403"
      }
    ],
    bowiBrokerId: -1,
    user: "",
    expanded: false
  },
  {
    allocationId: "00100644-ALLC-0001",
    symbol: "CHWY",
    side: "B",
    avgPrice: 10,
    totalQuantity: 20,
    totalValue: 200,
    orderDetail: [
      {
        allocationId: "00100644-ALLC-0001",
        orderId: 884191952,
        symbol: "CHWY",
        side: "B",
        execQuantity: 100,
        execPrice: 10,
        allcQuantity: 20,
        bowiBrokerId: -1
      }
    ],
    allocationDetails: [
      {
        allocationId: "00100644-ALLC-0001",
        accountId: "17281599",
        symbol: "CHWY",
        side: "B",
        price: 10,
        quantity: 10,
        ecnOrderId: "00100644-ALLC-0001-O0000-B0000",
        ecnExecId: "00100644-ALLC-0001-E0000-B0000",
        timestamp: "2024-05-21T13:32:52.05"
      },
      {
        allocationId: "00100644-ALLC-0001",
        accountId: "543028QA",
        symbol: "CHWY",
        side: "B",
        price: 10,
        quantity: 10,
        ecnOrderId: "00100644-ALLC-0001-O0001-B0000",
        ecnExecId: "00100644-ALLC-0001-E0001-B0000",
        timestamp: "2024-05-21T13:32:52.137"
      }
    ],
    bowiBrokerId: -1,
    user: "",
    expanded: false
  }
];
